/* ==========================================================
   SQUISHIX — Sound Effects
   Soft "pop" on Add to Cart, gentle chime on hover of product cards.
   ========================================================== */

(function () {
  var STORAGE_KEY = "squishix_sound_enabled";
  var soundEnabled = localStorage.getItem(STORAGE_KEY) !== "false";
  var audioUnlocked = false;

  var popSound = new Audio(
    "https://cdn.shopify.com/s/files/1/0813/6759/7286/files/pop.mp3?v=1783958377"
  );
  var chimeSound = new Audio(
    "https://cdn.shopify.com/s/files/1/0813/6759/7286/files/chime.mp3?v=1783958714"
  );
  popSound.volume = 0.5;
  chimeSound.volume = 0.25;

  // Unlock browser audio restriction on first user interaction
  function unlockAudio() {
    if (audioUnlocked) return;
    [popSound, chimeSound].forEach(function (sound) {
      sound.play().then(function () {
        sound.pause();
        sound.currentTime = 0;
      }).catch(function () {});
    });
    audioUnlocked = true;
    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("touchstart", unlockAudio);
  }

  document.addEventListener("click", unlockAudio);
  document.addEventListener("touchstart", unlockAudio);

  function playSound(audio) {
    if (!soundEnabled) return;
    audio.currentTime = 0;
    audio.play().catch(function (err) {
      /* Safe to ignore blocked autoplay */
    });
  }

  function bindStoreEvents() {
    // 1. Play POP sound on Add to Cart button click or form submit
    document.addEventListener("click", function (e) {
      var btn = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
      if (btn) {
        playSound(popSound);
      }
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form && form.querySelector && form.querySelector('[name="add"]')) {
        playSound(popSound);
      }
    });

    // 2. Play CHIME sound on product card hover (using event delegation for dynamic cards)
    var lastChime = 0;
    document.addEventListener("mouseover", function (e) {
      var card = e.target.closest(".card, .product-card, [class*='product-card'], .card-wrapper");
      if (card && !card.dataset.chimeBound) {
        var now = Date.now();
        if (now - lastChime > 800) {
          playSound(chimeSound);
          lastChime = now;
        }
      }
    });
  }

  function createFloatingBackground() {
    var layer = document.createElement("div");
    layer.className = "squishix-bg-layer";
    layer.setAttribute("aria-hidden", "true");
    var symbols = ["bubble", "bubble", "sparkle"];
    for (var i = 0; i < 12; i++) {
      var span = document.createElement("span");
      var kind = symbols[i % symbols.length];
      span.className = kind;
      if (kind === "sparkle") span.textContent = "✨";
      layer.appendChild(span);
    }
    document.body.appendChild(layer);
  }

  document.addEventListener("DOMContentLoaded", function () {
    createFloatingBackground();
    bindStoreEvents(); // Removed createMuteButton() to fix error
  });
})();